import Header from './components/Header';
import Intro from './components/Intro';
import Features from './components/Features';
import Extensions from './components/Extensions';
import Ask from './components/Ask';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-medium">
      <Header />
      <Intro />
      <Features />
      <Extensions />
      <Ask />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
